/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createDemandStatusResponseSchema = z.object({
  id: z.int(),
});
